/* ARONA — măsurarea expunerii pe produs (P10.5, 10 oct 2026). Varianta GENERALĂ pentru temele Tinker (Nubra, GT, Esteban…):
   cardul = elementul <product-card> (ID-ul din [data-product-id]); sursa ATC se deduce din click-ul care a dus la /cart/add.
   Sursa: esteban.ro/theme/assets/est-track.js. Contract: esteban.ro/_reports/P10.5-catalog/CONTRACT-EVENIMENTE.md.
   Publică evenimente custom prin Shopify.analytics.publish (le preia pixelul custom „Arona Catalog” → GA4). Nu trimite nimic singur în rețea.
   - est_list_impressions: carduri văzute ≥ 50% timp de ≥ 1 s, o dată per pagină, în loturi (10 carduri / 5 s / la ieșirea din pagină)
   - est_select_item: click pe card (link spre produs)
   - est_add_to_cart: adăugare în coș cu sursa (card / pdp / pdp_sticky) + lista și poziția de origine
   - est_view_item: pagina de produs, cu lista și poziția din care a venit omul (sessionStorage, 30 min)
   Depanare: ?est_debug=1 (sau localStorage est_debug=1) scrie evenimentele în consolă. */
(() => {
  if (window.__estTrack) return;
  window.__estTrack = true;
  const ctx = window.EST_CTX || {};
  /* ?est_debug=1 → modul de depanare ținut minte în sesiune (consolă + DebugView GA4); ?est_debug=0 îl oprește. */
  try { const m = location.search.match(/[?&]est_debug=([01])/); if (m) sessionStorage.setItem('est_debug', m[1]); } catch (e) { /* privat */ }
  const debug = (() => { try { return sessionStorage.getItem('est_debug') === '1' || localStorage.getItem('est_debug') === '1'; } catch (e) { return /[?&]est_debug=1/.test(location.search); } })();
  const KEY = 'est_origin';
  const TTL = 30 * 60 * 1000;

  /* ---- trimitere directă în GA4 (fără pixel manual): doar cu acordul de analiză din bannerul Shopify ---- */
  const GA4 = ctx.ga4 || '';
  let gaReady = false;
  const pending = [];
  const allowed = () => { try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch (e) { return false; } };
  const gtag = function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
  const startGa = () => {
    if (gaReady || !GA4 || !allowed()) return;
    gaReady = true;
    const s = document.createElement('script');
    s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
    document.head.appendChild(s);
    gtag('js', new Date());
    gtag('config', GA4, debug ? { send_page_view: false, debug_mode: true } : { send_page_view: false });
    pending.splice(0).forEach((a) => gtag(...a));
  };
  document.addEventListener('visitorConsentCollected', startGa);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => startGa());
  const toGa = (name, d) => {
    if (!GA4) return;
    const it = (i) => ({ item_id: String(i.item_id || d.item_id || ''), item_name: i.item_name || d.item_name || '', index: Number(i.index ?? d.index ?? 0), price: Number(i.price ?? d.price ?? 0), item_list_id: d.list_id || '', item_list_name: d.list_name || '' });
    let ev = null;
    if (name === 'est_list_impressions') ev = ['event', 'view_item_list', { item_list_id: d.list_id, item_list_name: d.list_name, list_id: d.list_id, items: (d.items || []).map(it) }];
    else if (name === 'est_select_item') ev = ['event', 'select_item', { item_list_id: d.list_id, item_list_name: d.list_name, list_id: d.list_id, list_index: d.index, items: [it({})] }];
    else if (name === 'est_view_item') ev = ['event', 'est_view_item', { prod_id: String(d.item_id || ''), list_id: d.list_id, list_index: d.index, value: d.price, currency: 'RON' }];
    else if (name === 'est_add_to_cart') ev = ['event', 'est_add_to_cart', { prod_id: String(d.item_id || ''), list_id: d.list_id, list_index: d.index, atc_source: d.source, value: Number(d.price || 0) * Number(d.quantity || 1), currency: 'RON' }];
    if (!ev) return;
    if (debug) ev[2].debug_mode = true;
    if (gaReady) gtag(...ev); else if (allowed()) { pending.push(ev); startGa(); } else if (pending.length < 50) pending.push(ev);
  };

  const publish = (name, data) => {
    const payload = { ...data, page_type: ctx.tpl || '', site: ctx.shop || location.hostname };
    if (debug) console.log(`%c[arona-track] ${name}`, 'color:#0a7', payload.items ? payload.items.map((i) => `${i.index}:${i.item_name}`).join(' · ') : `${payload.list_id || ''} #${payload.index || ''} ${payload.item_name || ''} ${payload.source || ''}`.trim(), payload);
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (e) { /* fără pixel = fără efect */ }
    toGa(name, payload);
  };

  /* ---- lista în care stă un card ---- */
  const sectionOf = (el) => el.closest('.shopify-section, [id^="shopify-section-"]');
  const listOf = (card) => {
    if (card.closest('.search-panel, predictive-search-component, .predictive-search')) return { id: 'search_panel', name: 'Căutare rapidă' };
    if (card.closest('cart-drawer-component, .cart-drawer, .cart-items, [data-est-upsell]')) return { id: 'cart', name: 'Coș' };
    const sec = sectionOf(card);
    const raw = sec?.id || '';
    const key = raw.includes('__') ? raw.split('__').pop() : raw.replace('shopify-section-', '') || 'other';
    const heading = [...(sec?.querySelectorAll('h1, h2, h3, .h1, .h2, .h3') || [])].find((h) => !h.closest('product-card'))?.textContent?.trim()?.replace(/\s+/g, ' ')?.slice(0, 80) || '';
    if (ctx.tpl === 'collection' && /main|product.grid|grid/.test(key)) return { id: `collection:${ctx.coll}`, name: ctx.collTitle || ctx.coll };
    if (ctx.tpl === 'search') return { id: 'search', name: `Căutare: ${ctx.search || ''}`.trim() };
    return { id: `${ctx.tpl || 'page'}:${key}`, name: heading || key };
  };
  const CARD = 'product-card, [data-arona-card]';
  const pidOf = (card) => card.dataset.estPid || card.querySelector('[data-product-id]')?.dataset.productId || card.dataset.productId || '';
  const cardsIn = (root) => [...root.querySelectorAll(CARD)].filter((c) => pidOf(c) && c.offsetParent !== null);
  const infoOf = (card) => {
    const list = listOf(card);
    const scope = (card.closest('.search-panel, cart-drawer-component, .cart-drawer') || sectionOf(card) || document.body);
    const index = cardsIn(scope).indexOf(card) + 1;
    return {
      list_id: list.id, list_name: list.name, index,
      item_id: pidOf(card),
      item_name: card.dataset.aronaName || (['h3', '.est-card__name', '[class*="card__title"]', 'a[href*="/products/"]'].map((q) => card.querySelector(q)?.textContent?.trim()).find(Boolean) || card.querySelector('img')?.alt || '').replace(/\s+/g, ' ').split(',')[0].slice(0, 80),
      price: 0,
    };
  };

  /* ---- afișări: ≥ 50% vizibil, ≥ 1 s, o dată per card per pagină ---- */
  const seen = new WeakSet();
  const timers = new WeakMap();
  let queue = [];
  const flush = () => {
    if (!queue.length) return;
    const byList = {};
    for (const it of queue) (byList[it.list_id] ||= { list_id: it.list_id, list_name: it.list_name, items: [] }).items.push({ item_id: it.item_id, item_name: it.item_name, index: it.index, price: it.price });
    queue = [];
    Object.values(byList).forEach((b) => publish('est_list_impressions', b));
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const e of entries) {
      const card = e.target;
      if (seen.has(card)) continue;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) {
        if (!timers.has(card)) timers.set(card, setTimeout(() => {
          seen.add(card); timers.delete(card); io.unobserve(card);
          queue.push(infoOf(card));
          if (queue.length >= 10) flush();
        }, 1000));
      } else if (timers.has(card)) { clearTimeout(timers.get(card)); timers.delete(card); }
    }
  }, { threshold: [0, 0.5] }) : null;
  const watch = (root = document) => { if (io) cardsIn(root).forEach((c) => { if (!seen.has(c)) io.observe(c); }); };
  setInterval(flush, 5000);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);
  /* carduri adăugate mai târziu (paginare infinită, căutare, coș) */
  let pend = 0;
  new MutationObserver((muts) => { if (!pend && muts.some((m) => m.addedNodes.length)) pend = setTimeout(() => { pend = 0; watch(); }, 400); }).observe(document.body, { childList: true, subtree: true });

  /* ---- click pe card → lista de origine pentru pagina de produs ---- */
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t || t.closest('[data-nb-add], button, quick-add-component')) return;
    const a = t.closest('a[href*="/products/"]');
    if (!a) return;
    const card = a.closest(CARD);
    if (!card) return;
    const info = infoOf(card);
    publish('est_select_item', info);
    try { sessionStorage.setItem(KEY, JSON.stringify({ pid: info.item_id, list_id: info.list_id, list_name: info.list_name, index: info.index, t: Date.now() })); } catch (err) { /* privat */ }
  }, true);

  const origin = (pid) => {
    try {
      const o = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (o && String(o.pid) === String(pid) && Date.now() - o.t < TTL) return o;
    } catch (e) { /* privat */ }
    return null;
  };

  /* ---- pagina de produs ---- */
  if (ctx.tpl === 'product' && ctx.pid) {
    const o = origin(ctx.pid);
    publish('est_view_item', { item_id: String(ctx.pid), item_name: ctx.pname || '', price: ctx.price || 0, list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0 });
  }

  /* ---- adăugare în coș cu sursa ---- */
  document.addEventListener('est:atc', (e) => {
    const d = e.detail || {};
    let info = {};
    if (d.source === 'card' && d.el) {
      const card = d.el.closest(CARD);
      if (card) info = infoOf(card);
    } else {
      const o = origin(d.productId);
      info = { list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0, item_id: String(d.productId || ''), item_name: d.name || '', price: Number(d.price || 0) };
    }
    const qty = (d.items || []).reduce((s, it) => s + (it.quantity || 0), 0) || 1;
    publish('est_add_to_cart', { ...info, item_id: info.item_id || String(d.productId || ''), source: d.source || 'other', quantity: qty });
    saveSrcLater((d.items || []).map((it) => String(it.id)), [info.list_id || '(direct)', Number(info.index || 0), d.source || 'other', Math.floor(Date.now() / 1000)]);
  });
  const saveSrcLater = (ids, entry) => setTimeout(() => saveSrc(ids, entry), 0);

  /* ---- atribuirea vânzării (ca un SERP): pe coș, atributul ascuns `_arona_src` = {variantă: [listă, poziție, sursă, ts]} ----
     Ultimul click câștigă. Atributul pleacă în comandă (note_attributes) → ERP: venit pe listă și pe poziție. Clientul nu-l vede. */
  const SRC_KEY = 'arona_src';
  const of = window.fetch;
  const saveSrc = (variantIds, entry) => {
    if (!variantIds.length) return;
    let m = {};
    try { m = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}'); } catch (e) { m = {}; }
    variantIds.forEach((v) => { m[String(v)] = entry; });
    const keys = Object.keys(m);
    if (keys.length > 40) keys.sort((a, b) => (m[a][3] || 0) - (m[b][3] || 0)).slice(0, keys.length - 40).forEach((k) => delete m[k]);
    try { sessionStorage.setItem(SRC_KEY, JSON.stringify(m)); } catch (e) { /* privat */ }
    const route = (window.Shopify?.routes?.root || '/') + 'cart/update.js';
    of.call(window, route, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _arona_src: JSON.stringify({ v: 1, i: m }) } }) }).catch(() => {});
  };
  const parseBody = (body) => {
    const out = { ids: [], qty: 0 };
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        const id = body.get('id'); if (id) out.ids.push(String(id));
        out.qty = Number(body.get('quantity') || 1);
        return out;
      }
      const b = typeof body === 'string' ? JSON.parse(body || '{}') : body || {};
      (b.items || [b]).forEach((it) => { if (it && it.id) out.ids.push(String(it.id)); out.qty += Number(it?.quantity || 1); });
    } catch (e) { /* corp necunoscut */ }
    if (!out.qty) out.qty = 1;
    return out;
  };
  const record = (info, source, body) => {
    const { ids, qty } = parseBody(body);
    publish('est_add_to_cart', { ...info, source, quantity: qty });
    saveSrc(ids, [info.list_id || '(direct)', Number(info.index || 0), source, Math.floor(Date.now() / 1000)]);
  };

  /* ATC generic: orice cerere /cart/add (fetch sau XHR). Sursa = ultimul click: în card → card, pe pagina de produs → pdp. */
  let lastTarget = null;
  document.addEventListener('pointerdown', (e) => { lastTarget = e.target instanceof Element ? e.target : null; }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') lastTarget = document.activeElement; }, true);
  document.addEventListener('submit', (e) => { lastTarget = e.submitter || e.target; }, true);
  let estAtcSeen = 0;
  document.addEventListener('est:atc', () => { estAtcSeen = Date.now(); }, true);
  const onAdded = (tgt, body) => {
    if (Date.now() - estAtcSeen < 3000) return;
    const card = tgt?.closest?.(CARD);
    if (card) { record(infoOf(card), 'card', body); return; }
    if (ctx.tpl === 'product' && ctx.pid) {
      const o = origin(ctx.pid);
      const sticky = !!tgt?.closest?.('[class*="sticky"], [class*="sbar"]');
      record({ item_id: String(ctx.pid), item_name: ctx.pname || '', price: ctx.price || 0, list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0 }, sticky ? 'pdp_sticky' : 'pdp', body);
      return;
    }
    const inCart = tgt?.closest?.('cart-drawer-component, .cart-drawer, [class*="cart"]');
    record({ item_id: '', list_id: inCart ? 'cart' : '(other)', list_name: '', index: 0 }, 'other', body);
  };
  const isAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(url || '');
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const p = of.apply(this, arguments);
    if (isAdd(url)) {
      const tgt = lastTarget;
      p.then((r) => { if (r.ok) onAdded(tgt, init?.body); }).catch(() => {});
    }
    return p;
  };
  const xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__aronaAdd = isAdd(String(url)); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__aronaAdd) { const tgt = lastTarget; this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) onAdded(tgt, body); }); }
    return xs.apply(this, arguments);
  };

  const start = () => watch();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
